module.exports = __webpack_public_path__ + "img/87.cf35bddc.jpg";